// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/imgs/invitation-card/background.jpg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".invitation-card[data-v-24c9769d] {\n  width: 10rem;\n  height: 19.01333rem;\n  background: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");\n  background-size: 100% 100%;\n  position: relative;\n}\n.btn[data-v-24c9769d] {\n  width: 3.2rem;\n  height: 0.85333rem;\n  position: absolute;\n  right: 1.2rem;\n  bottom: 4.98667rem;\n}", ""]);
// Exports
module.exports = exports;
